var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n  font-family: \"ZhenyanGB\";\r\n  src: url(" + escape(require("./RuiZiZhenYanTiMianFeiShangYong-2.ttf")) + ") format('truetype');\r\n  font-weight: normal;\r\n  font-style: normal\r\n}\r\n", ""]);

// exports
